import React, { useEffect, useRef } from 'react';

import { useField } from '@unform/core';

import { Container } from './styles';

interface Props {
  name: string;
  label?: string;
  optional?: boolean;
  disabled?: boolean;
  textAfter?: string;
}
type InputProps = JSX.IntrinsicElements['input'] & Props;
const Input: React.FC<InputProps> = ({
  name,
  label = null,
  optional = false,
  disabled = false,
  textAfter = '',
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);
  useEffect(() => {
    registerField({
      name: fieldName,
      path: 'value',
      ref: inputRef.current,
    });
  }, [fieldName, registerField]);
  return (
    <Container disabled={disabled}>
      {(label || optional) && (
        <div>
          {label && <label htmlFor={fieldName}>{label}</label>}
          {optional && <small>(opcional)</small>}
        </div>
      )}
      <div>
        <input
          id={fieldName}
          ref={inputRef}
          defaultValue={defaultValue}
          disabled={disabled}
          {...rest}
        />
        {textAfter && <p>{textAfter}</p>}
      </div>
      {error && <span>{error}</span>}
    </Container>
  );
};
export default Input;
